import CollectionQueryForm from 'Components/ComponentLibrary/Molecules/CollectionQueryForm';
import { metaOverrideSet } from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTableFilters/metaOverrideSet';
import PlannerTransitionTableFiltersLayout from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTableFilters/PlannerTransitionTableFiltersLayout';
import React from 'react';
import PropTypes from 'prop-types';

const PlannerTransitionTableFilters = ({
  plannerTransitionCollection,
  setPlannerTransitionCollection,
  plannerTransitionCollectionLoading,
}) => {
  return (
    <CollectionQueryForm
      collection={plannerTransitionCollection}
      metaOverrideSet={metaOverrideSet}
      layout={PlannerTransitionTableFiltersLayout}
      LayoutProps={{
        plannerTransitionCollectionLoading,
      }}
      onSubmit={(resultCollection) => {
        // Set the page context to have this as its state
        setPlannerTransitionCollection(resultCollection);
      }}
    />
  );
};

PlannerTransitionTableFilters.defaultProps = {
  plannerTransitionCollectionLoading: false,
};

PlannerTransitionTableFilters.propTypes = {
  plannerTransitionCollection: PropTypes.object.isRequired,
  setPlannerTransitionCollection: PropTypes.func.isRequired,
  plannerTransitionCollectionLoading: PropTypes.bool,
};

export default PlannerTransitionTableFilters;
